<template>
  <panel title="未读消息" class="mgb10">
    <template v-slot:right>
      <router-link to="/normal/messages/receive" class="small-link"
        >查看更多</router-link
      >
    </template>
    <ul class="msgs" v-if="records.length !== 0">
      <li v-for="row of records" :key="row.id">
        <span v-if="row.type != null">
          <span
            v-if="!['sys'].includes(row.type)"
            class="blue"
            @click="showRow(row)"
          >
            单号: {{ row.serialNo }}
          </span>
          <span v-else>单号: {{ row.serialNo }}</span>
        </span>

        <div class="info">
          <raw-html-limit-number
            :content="row.content"
            :number="25"
            type="richText"
            style="font-size: 17px"
          />
        </div>
        <div class="flex flex-between mgt10">
          <div class="send">{{ row.senderName }}({{ row.sendAt }})</div>
          <div><span class="read-btn" @click="read(row)">已读</span></div>
        </div>
      </li>
    </ul>
    <div class="vxe-table--empty-content center" v-else>暂无数据</div>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order
        :uuid="rowUuid"
        v-if="
          (rowEntity == 'Purchase' && ['cus2SupMes'].includes(rowType)) ||
          (rowEntity == 'Order' && !['sup2CusMes'].includes(rowType))
        "
      />
      <show-purchase
        :uuid="rowUuid"
        v-if="
          (rowEntity == 'Order' && ['sup2CusMes'].includes(rowType)) ||
          (rowEntity == 'Purchase' && !['cus2SupMes'].includes(rowType))
        "
      />
    </drawer>
  </panel>
</template>

<script>
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Notice from "@/api/notice.js";
import Util from "@/utils";
import ShowOrder from "@/views/messages/showOrder";
import ShowPurchase from "@/views/messages/showPurchase";
export default {
  components: {
    RawHtmlLimitNumber,
    ShowOrder,
    ShowPurchase,
  },
  data() {
    return {
      records: [],

      rowEntity: null,
      rowType: null,
      rowUuid: null,
      showDF: false,
    };
  },
  created() {
    const self = this;
    Notice.searchReceived({
      read: "no",
      currentPage: 1,
      pageSize: 10,
    }).then(function (res) {
      if (res.status === 200) {
        self.records = res.data.records;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    showRow(row) {
      this.rowEntity = row.entity;
      this.rowType = row.type;
      this.rowUuid = row.uuid;
      this.showDF = true;
    },

    loadData() {
      Notice.searchReceived({
        read: "no",
        currentPage: 1,
        pageSize: 10,
      }).then(function (res) {
        if (res.status === 200) {
          self.records = res.data.records;
        } else {
          self.sysError();
        }
      });
    },
    read(row) {
      const self = this;
      Notice.read(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.readSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>

<style scoped>
ul.msgs {
  list-style: none;
  margin: 0;
  padding: 0;
}
ul.msgs li {
  font-size: 13px;
  line-height: 24px;
  color: #606266;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
ul.msgs li:last-child {
  border-bottom: none;
  margin-bottom: none;
}
.send {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #999;
}
.read-btn {
  padding: 3px 5px;
  border-radius: 3px;
  color: #409eff;
  border: 1px solid #b3d8ff;
  background: #ecf5ff;
  font-size: 10px;
  cursor: pointer;
}
</style>